<template>
  <div class="container-fluid px-0">
    <h2 class="page-title text-center">VERIFICACIÓN DE FIRMAS</h2>
    <br>
    <div class="container-fluid">
      <div class="row d-flex px-lg-5">
        <div class="col-12 padding-div-low">


          <div v-if="firmas" class="area-claro" :key="index">


            <div>

              <div v-if="!firmasfirmanovigente">

                <h4 style="color: black; text-align: center">FIRMA VIGENTE</h4>
                

              </div>


              <div v-else>

                <h4 style="color: black; text-align: center">FIRMA NO VIGENTE</h4>
                

              </div>

              
              

            </div>


            
            


          <transition name="fade">



         <!--  <div v-if="(firmas == undefined || firmas == null || firmas.length <= 0)" style="background-color:white; padding: 8px;">

            <div class="d-flex justify-content-center">
              <i class="fas fa-check mr-sm-2" style="font-size: 25px;"></i>
              <div class="align-content-center">
                <h5>Verificación de recibo de firmas a encontrar</h5>
                 Esto es lo que se muestra antes de la busqueda 
              </div>
            </div>
          </div> -->


          <TablaDeResultadosFirmas 
            v-if="firmas != undefined && firmas != null"
            
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="accionesdelaTablaDeResultadosFirmas"
            :TablaVerificacionReciboDeFirmas="firmas"
            :TablaVerificacionReciboDeFirmasFecha="firmasfecha"
            :TablaVerificacionReciboDeFirmasFechaActual="firmasfechaactual"
            :TablaVerificacionReciboDeFirmasFirmaNoVigente="firmasfirmanovigente"
            :tituloTablaVerificacionReciboDeFirmas="tituloTablaString"
            >

          </TablaDeResultadosFirmas>
          </transition>


            








          




        </div >


        <div v-else-if="mensajeerror" class="area-claro " :key="index">
            <h4 style="color: black; text-align: center">FIRMA NO ENCONTRADA</h4>
          </div>



      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import func from '../../../SIVAC/Comun/Funciones/comun.js'
  import TablaDeResultadosFirmas from '@/components/SIVAC/Comun/TablaDeResultadosFirmas'
  import FiltroVerificacionReciboDeFirmas from '@/components/SIVAC/Comun/FiltroVerificacionReciboDeFirmas'

  export default {
    components: {
      FiltroVerificacionReciboDeFirmas,
      TablaDeResultadosFirmas
      },

    data() {
      return {
        enumeraciones,
        enumeraciones_sicpo,
        nombreDeVariableDelComponente: "cargoPaginaOficial",
        qr: String,
        index: 0,
        urlVerificar : String,


        firmas: null,
        firmasfecha:null,
        firmasfechaactual:null,
        firmasfirmanovigente:null,
        mensajeerror: null,
        Firma: null,
        FechaInicial: null,
        FechaFinal: null,
        tituloTablaString: '',
        tituloSeleccionadodelFiltro: '',


        accionesdelaTablaDeResultadosFirmas:{
            alta: true,
            impresion: true,
            cambios: true,
            visualizacion: true,
            altamanual: true,
            bajapersona: true,
            mensaje: true,
            output: null,
            reportes: true,
            consulta: false,
            verificacion: true,
        },




        
      }




    },

    

    beforeMount(){
      //
      this.qr = this.$route.query.qr
       

        this.firmasfecha= null; 
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Hash: this.qr


        }

          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.verificacion.firmas.BuscarVerificaciondeRecibodeFirmas, parametros, headerPeticion)
          .then(respuesta => { 
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.mensajeerror= respuesta.data.Error.Mensaje;
            } else {
              //Cargar Datos de Procesados
              this.firmas = respuesta.data.Firmas;
              this.firmasfechaactual= respuesta.data;
              this.firmasfirmanovigente= respuesta.data.FirmaNoVigente;
              this.$nextTick(()=> { PaginarTabla('tablaVerificacionReciboDeFirmasPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = "Comprobante de verificación del recibo de una firma";
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        




    },




    mounted() {
      this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
      
    },


    methods: {

      

      /** 
       * Metodo encargado de habilitar los componentes de acuerdo a la acción seleccionada (alta, impresion, alta manual, baja procesado)
       * en la tabla de resultados.
       * @param {object} datos [datos: Accion{Alta, Impresión, Alta Manual y Baja Procesado}]
       */
      accionRealizar:function(datos)
      {



      },


       /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.firmas = null;
      },


      /** 
       * Metodo encargado de limpiar los valores de Firma.
       */
      limpiarValores: function()
      {
        
        this.Firma = null;
        
      },



      FechaAPalabras: function(fecha){
          return func.FechaAPalabras(fecha)
      },
      agregarCeros : function(monto){
          return func.agregarCeros(monto)
      },
      numerosAPalabras: function(numero){
          return func.numerosAPalabras(numero)
      },
    }
  }
</script>

<style scoped>
  .page-title {
    background-color: rgb(0,117,115);
    color: #FFF;
    padding: 2vh 20vw;
  }

  .div-principal-verificacionFirmas .alert-dark {
    color: black;
    background-color: #545757;
    border-color: #c6c8ca;
  }

  .alert-info-verificacionFirmas p > span {
    font-weight: 900;
    font-size: 1.3em;
  }


</style>





// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/VerificacionDeFirmas/VerificacionDeFirmas.vue